module.exports = __webpack_public_path__ + "img/instagram.a5450efe.png";